"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var datapoints_1 = require("./datapoints");
var selectDefaultFolder_1 = require("./selectDefaultFolder");
var selectNodeInFolderForest_1 = require("./selectNodeInFolderForest");
var onAfterSelectingNode_1 = require("./helpers/onAfterSelectingNode");
var owa_mail_favorites_store_1 = require("owa-mail-favorites-store");
var owa_mail_folder_forest_store_1 = require("owa-mail-folder-forest-store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Select a persona node
 * @param personaId the folderId
 * @return a promise that resolves when the load persona table from server has completed
 */
exports.default = legacy_1.action('selectPersona', datapoints_1.default.selectPersona)(function selectPersona(personaId) {
    var selectNodePromise;
    // Only perform the rest of selecting folder logic when
    // user navigates to a folder with the different folderId
    if (personaId != owa_mail_folder_forest_store_1.getSelectedNode().id) {
        var persona = owa_mail_favorites_store_1.favoritesStore.favoritesPersonaNodes.get(personaId);
        if (!persona) {
            selectDefaultFolder_1.default();
            return Promise.resolve();
        }
        selectNodePromise = selectNodeInFolderForest_1.default(persona);
        owa_mail_favorites_store_1.lazyOnFavoritePersonaSelected.importAndExecute(persona.id);
    }
    // Called after selecting same/different persona
    // #15945 - We should try to merge SelectFolder, SelectPersona, SelectGroup logic and move this method into a common place
    onAfterSelectingNode_1.default();
    return selectNodePromise;
});
//# sourceMappingURL=selectPersona.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-folder-forest-actions/lib/actions/selectPersona.js
// module id = 4737
// module chunks = 23